import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-EDM-batch",
  "use": "icon-EDM-batch-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-EDM-batch\"><defs><style type=\"text/css\"></style></defs><path d=\"M694.592 0l240.96 194.56v648.704h-144.64v156.672H56.128V144.576l156.608-0.064V0h481.92z m-481.92 216.832H128.384v710.784h590.272v-84.352H212.672V216.832z m451.712-144.576H284.992v698.752h578.24V271.04H664.384V72.32z m176.064 138.56l-115.776-93.568v93.568h115.84z\" p-id=\"11332\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol